import { NavItemType } from '@/router/type'

const medicalRecordTemplates: NavItemType[] = [
  {
    id: 'medical-record-templates',
    title: 'Config de Prontuário',
    url: '/templates-prontuario',
    icon: 'medical-certificate',
    type: 'item',
    pathname: '/templates-prontuario',
  },
]

export default medicalRecordTemplates
